import script from "./itemV3StonesGroupSingle.vue?vue&type=script&setup=true&lang=ts"
export * from "./itemV3StonesGroupSingle.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__